import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const Login = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "login" */ './hocs')),
});
